import { render, staticRenderFns } from "./SidebarPreview.vue?vue&type=template&id=77d2783b&"
import script from "./SidebarPreview.vue?vue&type=script&lang=js&"
export * from "./SidebarPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/html/nextcloud/apps/dicomviewer/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d2783b')) {
      api.createRecord('77d2783b', component.options)
    } else {
      api.reload('77d2783b', component.options)
    }
    module.hot.accept("./SidebarPreview.vue?vue&type=template&id=77d2783b&", function () {
      api.rerender('77d2783b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/views/SidebarPreview.vue"
export default component.exports